import React, { createContext, useContext, useState } from "react";

const UserContext = createContext(null);

export function UserProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem("user");
    if (stored) return JSON.parse(stored);
    if (process.env.NODE_ENV !== "production") {
      const fallback = { username: "devadmin", role: "admin", campus: "all" };
      localStorage.setItem("user", JSON.stringify(fallback));
      return fallback;
    }
    return null;
  });

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}